/* esm.sh - highlight.js@11.11.1/lib/languages/python-repl */
function n(a){return{aliases:["pycon"],contains:[{className:"meta.prompt",starts:{end:/ |$/,starts:{end:"$",subLanguage:"python"}},variants:[{begin:/^>>>(?=[ ]|$)/},{begin:/^\.\.\.(?=[ ]|$)/}]}]}}export{n as default};
//# sourceMappingURL=python-repl.mjs.map